import { createContext } from "react";
import { AdminData } from "./01Admin/Admin";
import { UserData } from "./02User/User";
import { Account } from "./Account";
import { IFAndonData } from "./DataTypes";

/**
 * アプリデータ
 */
class AppData {
  public account: Account = new Account();
  public dataAdmin: AdminData = new AdminData();
  public dataUser: UserData = new UserData();

  constructor() {
    if (sessionStorage["InfoUpdate"]) {
      clearInterval(sessionStorage["InfoUpdate"]);
      sessionStorage.removeItem("InfoUpdate");
    }
    const update = () => {
      if (this.account.IsAdmin()) {
        this.dataAdmin.Update();
      } else {
        this.dataUser.Update(this.account);
      }
    };
    sessionStorage["InfoUpdate"] = setInterval(update, 10000);
  }

  public GetAndonData(): IFAndonData {
    if (this.account.IsAdmin()) {
      return this.dataAdmin.andon;
    }
    return this.dataUser.andon;
  }
}

export const appData = new AppData();
export const AppContext = createContext(appData);
